import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClassroomFilterDto } from 'src/app/data/models/dto/classroom-filter.dto';
import { ClassRoomsService } from 'src/app/data/services/classroom.service';
import { UserUtil } from 'src/app/data/utils/user.utils';

@Component({
  selector: 'app-school-year-combo',
  templateUrl: './school-year-combo.component.html',
  styleUrls: ['./school-year-combo.component.scss'],
})
export class SchoolYearComboComponent implements OnInit {
  @Input() txtYear: string | undefined;
  @Output() yearSelected = new EventEmitter<string>();

  options: string[] = [];
  selected: string = '';
  txtLabel: string = 'Ano Letivo';
  idsSchool?: string[];

  constructor(
    private classroomsService: ClassRoomsService,
    private userUtil: UserUtil
  ) {
    this.idsSchool = this.userUtil.getSchools().map((school)=>school.id)
    const filter: ClassroomFilterDto = {
      idSchool: this.idsSchool![0]
    }
    this.classroomsService.getYears(filter).subscribe(
      (response) => {
        this.options = response;
      },
      (err) => {
        console.log(err);

        this.options = [this.currentYear];
        this.selected = this.currentYear;
      }
    );
  }
  ngOnInit(): void {
    this.selected = this.txtYear ? this.txtYear : this.currentYear;
  }

  getSelectedYear(year: string) {
    this.yearSelected.emit(year);
  }

  private currentYear = new Date().getFullYear().toString();
}
